import { queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { getUserProfile } from '../../api/userService';

import { userProfileKeys } from './keys';

export const userProfileOptions = (userId) =>
	queryOptions({
		queryKey: userProfileKeys.detail(userId),
		queryFn: async () => {
			if (!userId) return null;

			const { data, error } = await getUserProfile(userId);
			if (error) throw error;
			return data;
		},
		enabled: Boolean(userId),
		staleTime: STALE_TIMES.STABLE,
		retry: false,
	});
